<template>
  <v-container fluid>
      <section-title-with-request-id
      v-if="$parent.isRole(['SUPERVISOR', 'SUSTAINABILITY_MANAGER'])"
      :request-id="repairProp.number"
      :title="$parent.isRepairStatus(['IN_WAITING_COMPLETED']) ? 'pages.repair.repairInProgress' : 'pages.repair.repairCompleted'"
      class="mb-3"/>

      <v-row v-if="$parent.isNotRole(['SUPERVISOR', 'SUSTAINABILITY_MANAGER'])" dense>
          <v-col>
            <section-title-with-request-id
            :request-id="repairProp.number"
            title="pages.repair.completedRepairDetails"
            :subtitle="isEstimateDeliveryDateSet ? $t('pages.repair.expectDeliveryConfirmation', {'0': getDateNewYorkFormat(getEstimateDeliveryDate)}) : undefined"
            class="mb-3"/>
            <p 
            v-if="$parent.isRole(['CLIENT'])"
            class="process-repair-tab-section-subtitle font-weight-bold">
              {{$t('pages.repair.pleaseConfirmDeliveryCompletedTab')}}
            </p>
          </v-col>
      </v-row>
      <v-row 
      dense 
      class="my-10">
        <v-col class="d-flex justify-center align-center">
          <process-repair-quick-btns
          :config="getQuickBtnsConfig"
          :loading.sync="isLoading"
          on-success-repair-status-message="dialogs.messages.success.confirmedPackageReceivedBackSuccessfully"/>
        </v-col>
    </v-row>
  </v-container>
</template>
<script>
import DateUtil from '@/utils/DateUtil'
import ProcessRepairQuickBtns from '@/components/process-repair-tabs/ProcessRepairQuickBtns'
import SectionTitleWithRequestId from '@/components/common/process-tabs/shared/SectionTitleWithRequestId'
export default {
  name: 'CompletedTabRepair',
  components: {
    ProcessRepairQuickBtns,
    SectionTitleWithRequestId
  },
  data() {
    return {
      isLoading: false
    }
  },
  props: {
    data: {
      type: Object,
      required: true
    },
    disabled: Boolean
  },
  methods: {
    getDateNewYorkFormat(d) {
      return DateUtil.getDateNewYorkFormat(d)
    },
    openSuccessDialog(message) {
      this.$successDialog.open(null, message, null)
    },
    openFailedDialog(message) {
      this.$failedDialog.open(null, message, null)
    }
  },
  computed: {
    getEstimateDeliveryDate() {
      return this.repairProp.transitBackShippingDetails.estimateDeliveryDate.replace(/T.+/, '').concat('T00:00:00.000+00:00')
    },
    repairProp: {
      get: function() {
        return this.$props.data
      },
      set: function(v) {
        this.$emit('update:data', v)
      }
    },
    isEstimateDeliveryDateSet() {
      return !!this.repairProp.transitBackShippingDetails.estimateDeliveryDate
    },
    getQuickBtnsConfig() {
      return [
        {
          name: 'ConfrimDelivery',
          props: {
            'disabled': this.$parent.isRepairStatus(['COMPLETED']) || this.$parent.isRepairStatus(['REJECTED']) || this.$parent.isRole(['SUPERVISOR', 'SUSTAINABILITY_MANAGER'])
          },
          events: 'AsContinue'
        }
      ]
    }
  }
}
</script>
<style>

</style>